import { render, staticRenderFns } from "./AddDailyChallenge.vue?vue&type=template&id=572d3cf2"
import script from "./AddDailyChallenge.vue?vue&type=script&lang=js"
export * from "./AddDailyChallenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports